import type { CmpHider } from './types';

export const sourcepoint: CmpHider = {
  id: 'sourcepoint',
  label: 'Sourcepoint',
  css: `
      /* Sourcepoint (Sourcepoint CMP, "by Didomi" but distinct from Didomi's
         #didomi-host markup): the consent message renders inside a fixed,
         full-viewport container "div[id^=sp_message_container_]" (z-index
         2147483647) that both dims the page and hosts a nested
         "iframe[id^=sp_message_iframe_]" served from a Sourcepoint domain. The
         container itself is the backdrop, so hiding it removes the dimmer and
         the message in one go; we also hide the message iframe and the older
         ".sp_veil" full-screen dimmer in case a build renders them separately.
         Sourcepoint locks page scroll by adding the "sp-message-open" class to
         <html>, whose own rule ".sp-message-open body { overflow: hidden;
         position: fixed }" is injected at runtime AFTER this style — matching
         its specificity plus !important loses on source order, so we lead with
         "html.sp-message-open body" (one extra type/class) to out-specify it,
         and also clear the height/width clamp the class puts on <html>. */
      div[id^="sp_message_container_"],
      iframe[id^="sp_message_iframe_"],
      .sp_veil { display: none !important; }
      html.sp-message-open {
        height: auto !important;
        width: auto !important;
        overflow: visible !important;
      }
      html.sp-message-open body {
        overflow: visible !important;
        position: static !important;
        margin-top: 0 !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
      }
  `,
};
